<div class="amd-main__header">
  <span class="amd-main__title">{{ title() | translate }}</span>
  @if (isDetail()) {
    <p-button
      [label]="'buttons.edit' | translate"
      size="small"
      (click)="editCompanyData()"
    ></p-button>
  } @else {
    <div class="flex gap-2">
      <p-button
        [label]="'buttons.cancel' | translate"
        size="small"
        severity="secondary"
        (click)="cancelEdit()"
      ></p-button>
      <p-button
        [label]="'buttons.save' | translate"
        size="small"
        [disabled]="form.invalid"
        [loading]="savingCompanyData()"
        (click)="saveCompanyData()"
      ></p-button>
    </div>
  }
</div>
<div class="amd-main__content">
  @if (isDetail()) {
    @if (!loadingCompanyData()) {
      <div class="amd-field">
        <span class="amd-label">{{
          "accountManagement.dialog.companyData.fields.companyName" | translate
        }}</span>
        <span class="amd-value">{{ companyData()?.RAZONSOCIAL || "-" }}</span>
      </div>
      <div class="amd-field">
        <span class="amd-label">{{
          "accountManagement.dialog.companyData.fields.email" | translate
        }}</span>
        <span class="amd-value">{{ companyData()?.MAIL || "-" }}</span>
      </div>
      <div class="amd-field">
        <span class="amd-label">{{
          "accountManagement.dialog.companyData.fields.cif" | translate
        }}</span>
        <span class="amd-value">{{ companyData()?.CIF || "-" }}</span>
      </div>
      <div class="amd-field">
        <span class="amd-label">{{
          "accountManagement.dialog.companyData.fields.phone" | translate
        }}</span>
        <span class="amd-value">{{ companyData()?.TELEFONO || "-" }}</span>
      </div>
      <div class="amd-field">
        <span class="amd-label">{{
          "accountManagement.dialog.companyData.fields.producerNumber"
            | translate
        }}</span>
        <span class="amd-value">{{ companyData()?.NUMPRODUCTOR || "-" }}</span>
      </div>
      <div class="amd-field">
        <span class="amd-label">{{
          "accountManagement.dialog.companyData.fields.web" | translate
        }}</span>
        <span class="amd-value">{{ companyData()?.WEB || "-" }}</span>
      </div>
      <div class="amd-field">
        <span class="amd-label">{{
          "accountManagement.dialog.companyData.fields.companyGroup" | translate
        }}</span>
        <span class="amd-value">{{ companyData()?.GRUPOCLIENTE || "-" }}</span>
      </div>
    } @else {
      @for (item of [1, 2, 3, 4, 5, 6, 7]; track $index) {
        <div class="amd-field">
          <span class="amd-label">
            <p-skeleton width="8rem" height="1rem"></p-skeleton>
          </span>
          <span class="amd-value">
            <p-skeleton width="15rem" height="1.5rem"></p-skeleton>
          </span>
        </div>
      }
    }
  } @else {
    <form [formGroup]="form">
      <eco-input-text
        label="accountManagement.dialog.companyData.fields.companyName"
        formControlName="RAZONSOCIAL"
      ></eco-input-text>
      <eco-input-text
        label="accountManagement.dialog.companyData.fields.email"
        formControlName="MAIL"
      ></eco-input-text>
      <eco-input-text
        label="accountManagement.dialog.companyData.fields.cif"
        formControlName="CIF"
      ></eco-input-text>
      <eco-input-text
        label="accountManagement.dialog.companyData.fields.phone"
        formControlName="TELEFONO"
      ></eco-input-text>
      <eco-input-text
        label="accountManagement.dialog.companyData.fields.producerNumber"
        formControlName="NUMPRODUCTOR"
      ></eco-input-text>
      <eco-input-text
        label="accountManagement.dialog.companyData.fields.web"
        formControlName="WEB"
      ></eco-input-text>
      <eco-input-text
        label="accountManagement.dialog.companyData.fields.companyGroup"
        formControlName="GRUPOCLIENTE"
      ></eco-input-text>
    </form>
  }
</div>
